import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GaTrackingEventName } from '~shared/modules/ga-tracking/constants';
import { GATrackingEventPayload } from '~shared/modules/ga-tracking/models';

export class PromoImageLinkClickApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.PromoImageLinkClick;

  constructor(private label: string, private currentPath: string) {}

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PromoImageLinkClick,
      label: this.label,
      gtmCustom: {
        'content-name': this.currentPath
      }
    };
  }
}
